import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Card, CardContent, Grid, GridColumn, Heading, Image, Separator } from 'telia-front-react';
const SpecialRequestCard = () => {
    const { translate } = React.useContext(TranslationsContext);
    return (React.createElement(Card, { type: "light", background: "neutral-bg-level-1", className: "text-left", elevation: 1 },
        React.createElement(CardContent, null,
            React.createElement(Grid, null,
                React.createElement(GridColumn, null,
                    React.createElement(Image, { align: "center", role: "presentation", width: 180, srcset: 'https://res.cloudinary.com/telia/image/upload/era/mobiil/5g/TC_Icon_Duo_Dark_Rocket.svg', sources: [
                            {
                                srcset: 'https://res.cloudinary.com/telia/image/upload/era/mobiil/5g/TC_Icon_Duo_Dark_Rocket.svg',
                                minWidth: '180px',
                            },
                        ] }),
                    React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
                    React.createElement(Heading, { level: 3 }, translate('secureNetCalculator.requestSpecialOffer.title')),
                    React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
                    React.createElement("p", null, translate('secureNetCalculator.requestSpecialOffer.content')),
                    React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
                    React.createElement("p", null, translate('secureNetCalculator.requestSpecialOffer.cta')))))));
};
export default SpecialRequestCard;
